import { __read } from 'tslib';
import * as React from 'react';
import classNames from 'classnames';
import BaseSectionWithAnalyticsContext from '../../common/BaseSection/BaseSectionWithAnalyticsContext.esm.js';
import { ExtraLargeImageContext } from '../../common/ContentfulImage/ExtraLargeImageContext.esm.js';
import { Grid } from '../../common/Grid/Grid.esm.js';
import { NvMarkdownInline, NvHeadline, NvMarkdown } from '@invitae/ids-react';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import useWindowDimensions from '../../hooks/useWindowDimensions.esm.js';
import { endsWith } from '../../utils/misc.esm.js';
import styles from './HeroShapeBlock.module.esm.js';

var getThemeClass = function (theme) { return classNames(styles[theme]); };
var MOBILE_HEIGHT_WITH_SECONDARY_LINK = 550;
var MOBILE_HEIGHT_WITHOUT_SECONDARY_LINK = 520;
var HeroShapeBlock = function (_a) {
    var _b;
    var _c = _a.fields, body = _c.body, heading = _c.heading, image = _c.image, theme = _c.theme, shape = _c.shape, link = _c.link, internalName = _c.internalName, secondaryLink = _c.secondaryLink, id = _a.id, dataCy = _a["data-cy"];
    var isAltTheme = endsWith(theme, 'Alt');
    var themeClass = getThemeClass(theme);
    var _d = useWindowDimensions(), isSmall = _d.isSmall, isExtraSmall = _d.isExtraSmall;
    var _e = __read(React.useState(0), 2), bodyTextHeight = _e[0], setBodyTextHeight = _e[1];
    var ref = React.useRef(null);
    var mobileHeight = secondaryLink ? MOBILE_HEIGHT_WITH_SECONDARY_LINK : MOBILE_HEIGHT_WITHOUT_SECONDARY_LINK;
    var injectedMobileHeight = isExtraSmall || isSmall ? { height: mobileHeight + bodyTextHeight } : {};
    React.useEffect(function () {
        if (ref.current)
            setBodyTextHeight(ref.current.clientHeight);
    }, [ref]);
    return (React.createElement(BaseSectionWithAnalyticsContext, { className: classNames(styles.root, themeClass), "data-cy": dataCy, id: id, sectionName: internalName, style: injectedMobileHeight },
        React.createElement(Grid, { className: styles.textGrid },
            React.createElement("div", { className: styles.text },
                React.createElement(NvMarkdownInline, { className: classNames(styles.heading, themeClass), elementWrapper: NvHeadline }, heading),
                body && (React.createElement("div", { className: classNames(styles.bodyText, themeClass), ref: ref },
                    React.createElement(NvMarkdown, { options: { forceWrapper: false } }, body))),
                React.createElement("div", { className: styles.actions },
                    link && (React.createElement(BaseNucleobaseComponent, { classes: {
                            link: classNames('nv-button', styles.link, {
                                'nv-button-white': !isAltTheme,
                            }),
                        }, source: link })),
                    secondaryLink && (React.createElement(BaseNucleobaseComponent, { classes: {
                            link: classNames('nv-button', 'nv-button-secondary', styles.link, styles.secondaryLink, {
                                'nv-button-white nv-button-secondary-white': !isAltTheme,
                            }),
                        }, source: secondaryLink }))))),
        React.createElement(Grid, { className: styles.imgGrid, withoutContainer: true },
            React.createElement("div", { className: classNames(styles.picture, (_b = {},
                    _b[styles.imgOverlayWrapperShapeOutwards] = !['inwards', 'outwards'].includes(shape) || shape === 'outwards',
                    _b[styles.imgOverlayWrapperShapeInwards] = shape === 'inwards',
                    _b)) },
                React.createElement(ExtraLargeImageContext, null,
                    React.createElement(BaseNucleobaseComponent, { alt: "", source: image }))))));
};

export { HeroShapeBlock as default };
//# sourceMappingURL=HeroShapeBlock.esm.js.map
